function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 376,
  fill: "#909ba6",
  r: 53
}), /*#__PURE__*/React.createElement("circle", {
  cx: 439,
  cy: 336,
  fill: "#c8d2dc",
  r: 46
}), /*#__PURE__*/React.createElement("circle", {
  cx: 397,
  cy: 112,
  fill: "#e9edf1",
  r: 38
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 56.245,
  cy: 244.754,
  fill: "#7e8b96",
  rx: 56.245,
  ry: 54.874
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 217.821,
  cy: 447.175,
  fill: "#a2abb8",
  rx: 51.132,
  ry: 49.825
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 349.229,
  cy: 427.873,
  fill: "#b9c3cd",
  rx: 48.575,
  ry: 47.297
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 117.092,
  cy: 114.794,
  fill: "#5f6c75",
  rx: 58.801,
  ry: 57.397
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 453.538,
  cy: 216.477,
  fill: "#dce6eb",
  rx: 43.462,
  ry: 42.656
}), /*#__PURE__*/React.createElement("circle", {
  cx: 263,
  cy: 62,
  fill: "#4e5a61",
  r: 62
}));

var SvgAudioLoading = function SvgAudioLoading(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 497 497",
    height: 512,
    viewBox: "0 0 497 497",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAudioLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audio-loading.ef19692c.svg";
export { ForwardRef as ReactComponent };